import { PricingTypes } from "../constants/defaultValues"

const calculatorRequiredKeys = [
  "variableNameInExpression",
  "variableLabelForDisplay",
  "scopeType",
  "source",
  "min",
  "max",
  "baseUnit"
]

const expressionRequiredKeys = ["variableNameInExpression", "scopeType", "parameter", "source"]

const expressionRequiredFieldsByScopeType = {
  "event-type": ["variableNameInExpression", "scopeType", "parameter", "source"],
  "user-count": ["variableNameInExpression", "scopeType"]
}

function isValidField(key: string, value?: string) {
  if (!value) {
    return false
  }

  switch (key) {
    case "min":
    case "max":
      return parseInt(value) > 0 && Number.isInteger(+value)
    case "parameter":
      return ["count", "rate", "limit", "checkoutSelection"].includes(value)
    default:
      return value.length > 0
  }
}

export function isValidPricingItem(pricingType: PricingTypes) {
  let requiredKeys: string[] = []
  let specialFilteringLogicForPricingType = false

  if (pricingType === PricingTypes.CALCULATOR) {
    requiredKeys = calculatorRequiredKeys
  }

  if (pricingType === PricingTypes.EXPRESSION) {
    requiredKeys = expressionRequiredKeys
    specialFilteringLogicForPricingType = true
  }

  return (pricingItem: App.Pricings) => {
    return requiredKeys
      .filter((key) => {
        if (specialFilteringLogicForPricingType) {
          return expressionRequiredFieldsByScopeType[pricingItem["scopeType"] ?? ""]?.includes(key) ?? true
        }

        return true
      })
      .every((key) => {
        if (!pricingItem[key]) {
          return false
        }

        if (key === "scopeType" && pricingItem["scopeType"] === "event-type") {
          return isValidField("parameter", pricingItem["parameter"])
        }

        return isValidField(key, pricingItem[key])
      })
  }
}
